import http from '../common/http'
import Configs from '../common/configs'

// 门店列表
export const getStoreList = () =>(
	http.get('/Recycle/GetStoreList')
)

// 获取二维码
export const getQrcode=param=>(
	http.get('/Recycle/GetQrcode',param)
  )



// WEBPACK FOOTER //
// ./src/api/recycleApi.js